import {Injectable} from '@angular/core';
import {AbstractModelService} from "../model/abstract-model.service";
import {Observable} from "rxjs";
import {ApiResponse} from "../../api/api-response";
import {ApiClientService} from '../api-client/api-client.service';
import {Document} from '../../models/document';

@Injectable({
  providedIn: 'root'
})
export class DocumentService extends AbstractModelService<Document> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/document', Document);
  }

  getContent(id: number): Observable<{content: string, contentType: string}> {
    return new Observable<{content: string, contentType: string}>((subscriber) => {
      this.apiClient.get(this.routePath + '/' + id + '/document').subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  upload(file: File): Observable<Document> {
    return new Observable<Document>((subscriber) => {
      const formData = new FormData();
      formData.append("file", file);

      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        const params = {
          name: file.name,
          data: String(fileReader.result).split(';base64,')[1]
        };

        this.apiClient.post(this.routePath, null, params).subscribe((response: ApiResponse) => {
          subscriber.next(new Document().deserialize(response.getData()['file']));
        });
      };

      fileReader.onerror = (error) => {
        subscriber.error(error);
      };
    });
  }
}
